<template>
  <div class="floating-actions">
    <!-- 电话按钮 -->
    <a 
      :href="`tel:${ SpgData.call }`"
      class="action-btn"
      title="联系电话"
      alt="联系电话"
    >
      <div class="action-btn-icon flicker"><i class="iconfont icon-tel" style="font-size: 38px;"></i></div>
      <div class="action-btn-cont" @click="copyInfo( SpgData.call,'电话' )"> {{ SpgData.call}} </div>
    </a>

    <!-- 调查问卷 -->
    <a 
      :href="SpgData?.questionnaire?.link"
      target="_blank"
      class="action-btn"
      title="答卷有礼"
      alt="答卷有礼"
      a
    >
      <div class="action-btn-icon flicker"><i class="iconfont icon-wenjuan" style="font-size: 34px;"></i></div>
      <div class="action-btn-cont" style="font-size: 16px;">{{ SpgData?.questionnaire?.title }}</div>
    </a>

    <!-- 留言按钮 -->
    <a 
      href="javascript:;"
      class="action-btn"
      title="发送留言"
      @click="drawer = true"
    >
      <div class="action-btn-icon"><i class="iconfont icon-liuyan" style="font-size: 36px;"></i></div>
    </a>
    
    <!-- 邮箱按钮 -->
    <a 
      :href="`mailto:${ SpgData.email }`"
      class="action-btn"
      title="发送邮件"
    >
      <div class="action-btn-icon"><i class="iconfont icon-email" style="font-size: 36px;"></i></div>
      <div class="action-btn-cont" @click="copyInfo( SpgData.email,'邮箱' )"> {{ SpgData.email }} </div>
    </a>
    
    <!-- 返回顶部按钮（使用transition包裹实现过渡动画） -->
    <transition name="backToTop">
      <button 
        v-if="showBackToTop"
        class="action-btn back-to-top"
        @click="scrollToTop"
        title="返回顶部"
      >
        <i class="iconfont icon-gotop1" style="font-size: 34px;"></i>
      </button>
    </transition>

    <!-- 写留言抽屉 -->
    <el-drawer
    :title="$t('ContactPage.message.title')"
    :visible.sync="drawer"
    :direction="direction"
    :modal-append-to-body="false"
    :before-close="handleClose"
    :lock-scroll="false"
    width="500px"
  >
    <el-form
      ref="messageForm"
      :model="messageForm"
      :rules="rules"
      label-width="80px"
      class="message-form"
    >
      <el-form-item :label="$t('ContactPage.message.name')[1]" prop="name">
        <el-input
          v-model="messageForm.name"
          :placeholder="$t('ContactPage.message.name')[0]"
          maxlength="20"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('ContactPage.message.cell')[0]" prop="contact">
        <el-input
          v-model="messageForm.contact"
          :placeholder="$t('ContactPage.message.contact')[0]"
          maxlength="50"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('ContactPage.message.cell')[1]" prop="type">
        <el-select
          v-model="messageForm.type"
          :placeholder="$t('ContactPage.message.type')"
        >
          <el-option :label="$t('ContactPage.message.option')[0]" :value="$t('ContactPage.message.option')[0]"></el-option>
          <el-option :label="$t('ContactPage.message.option')[1]" :value="$t('ContactPage.message.option')[1]"></el-option>
          <el-option :label="$t('ContactPage.message.option')[2]" :value="$t('ContactPage.message.option')[2]"></el-option>
          <el-option :label="$t('ContactPage.message.option')[3]" :value="$t('ContactPage.message.option')[3]"></el-option>
          <el-option :label="$t('ContactPage.message.option')[4]" :value="$t('ContactPage.message.option')[4]"></el-option>
          <el-option :label="$t('ContactPage.message.option')[5]" :value="$t('ContactPage.message.option')[5]"></el-option>
          <el-option :label="$t('ContactPage.message.option')[6]" :value="$t('ContactPage.message.option')[6]"></el-option>
          <el-option :label="$t('ContactPage.message.option')[7]" :value="$t('ContactPage.message.option')[7]"></el-option>
          <el-option :label="$t('ContactPage.message.option')[8]" :value="$t('ContactPage.message.option')[8]"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('ContactPage.message.cell')[2]" prop="content">
        <el-input
          v-model="messageForm.content"
          type="textarea"
          :rows="6"
          :placeholder="$t('ContactPage.message.content')[0] + '...'"
          maxlength="500"
        ></el-input>
        <div class="word-count">
          {{ messageForm.content.length }}/500
        </div>
      </el-form-item>

      <!-- <el-form-item label="是否匿名">
        <el-switch
          v-model="messageForm.anonymous"
          active-text="匿名提交"
          inactive-text="实名提交"
        ></el-switch>
      </el-form-item> -->

      <!-- <div class="form-group">
        <label>验证码：</label>
        <captcha 
          ref="captcha" 
          @input="checkCaptcha"
        ></captcha>
      </div> -->

      <el-form-item :label="$t('ContactPage.message.cell')[3]" required>
        <captcha 
          ref="captcha" 
          @input="checkCaptcha"
        ></captcha>
      </el-form-item>

      <el-form-item>
        <div class="form-actions">
          <el-button @click="resetForm('messageForm')">{{ $t('ContactPage.message.button')[0] }}</el-button>
          <el-button type="primary" @click="submitForm(messageForm)"><i class="el-icon-s-promotion" style="font-size: 16px;"></i> {{ $t('ContactPage.message.button')[1] }}</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-drawer>
  </div>
</template>

<script>
import Captcha from './captchaView.vue';
export default {
  name: 'FloatingActions',
  components: {
    Captcha
  },
  data() {
    return {
      showBackToTop: false,
      screenHeight: 0,
      drawer: false,
      direction: 'rtl', // 从右侧滑出
      isCaptchaValid: false,
      messageForm: {
        name: '',
        contact: '',
        type: '',
        content: '',
        time:''
        // anonymous: false
      },
      rules: {
        name: [
          { required: true, message: this.$t('ContactPage.message.name')[0], trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: this.$t('ContactPage.message.contact')[0], trigger: 'blur' },
          { min: 5, max: 50, message: '长度在 5 到 50 个字符', trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('ContactPage.message.type'), trigger: 'change' }
        ],
        content: [
          { required: true, message: this.$t('ContactPage.message.content')[1], trigger: 'blur' },
          { min: 5, max: 500, message: '长度在 5 到 500 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    SpgData: {
      type: Object,
      default: () => ({
      })
    }
  },
  mounted() {
    this.screenHeight = window.innerHeight
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    copyInfo(res, type) {
      const textarea = document.createElement('textarea')
      textarea.value = res
      textarea.style.position = 'absolute'
      textarea.style.left = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      const isSuccess = document.execCommand('copy')
      document.body.removeChild(textarea)
      if (isSuccess) {
        this.$notify({
          title: '复制成功',
          message: `已复制${type}"${res}"到剪贴板`,
          type: 'success',
          duration: 2000
        })
      } else {
        this.$notify({
          title: '复制失败',
          message: '请手动复制内容',
          type: 'error',
          duration: 2000
        })
      }
    },
    checkCaptcha() {
      // 验证验证码是否正确
      this.isCaptchaValid = this.$refs.captcha.validate();
    },
    // 提交表单
    submitForm(formName) {
      // 获取当前时间并格式化
      const now = new Date();      
      // 格式化年份
      const year = now.getFullYear();      
      // 格式化月份（月份从0开始，需+1，不足两位补0）
      const month = String(now.getMonth() + 1).padStart(2, '0');      
      // 格式化日期（不足两位补0）
      const day = String(now.getDate()).padStart(2, '0');      
      // 格式化小时（不足两位补0）
      const hours = String(now.getHours()).padStart(2, '0');      
      // 格式化分钟（不足两位补0）
      const minutes = String(now.getMinutes()).padStart(2, '0');      
      // 格式化秒钟（不足两位补0）
      const seconds = String(now.getSeconds()).padStart(2, '0');      
      // 拼接为 "yyyy-mm-dd hh:mm:ss" 格式
      this.messageForm.time = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      // console.log(this.isCaptchaValid,formName)
      if(!this.isCaptchaValid){
        this.$message.error(this.$t('ContactPage.message.captcha'));
      }else if(!this.messageForm.name){
        this.$message.error(this.$t('ContactPage.message.name'));
      }else if(!this.messageForm.content){
        this.$message.error(this.$t('ContactPage.message.content')[1]);
      }else if(!this.messageForm.type){
        this.$message.error(this.$t('ContactPage.message.type'));
      }else {
        // 等待添加操作完成
        this.$db.collection('SPG-WEB-Message').add(formName);
        // 提交成功的反馈
        this.$message.success('留言提交成功！我们会尽快回复您。');
        // 清空表单（可选）
        this.messageForm = {
            contact: '',
            content: '',
            name: '',
            type: '' // 根据你的默认值调整
        };
        // 关闭抽屉
        this.drawer = false;
      }

      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     // 处理匿名情况
      //     const submitData = { ...this.messageForm };
      //     // if (submitData.anonymous) {
      //     //   submitData.name = '匿名用户';
      //     //   submitData.contact = '未提供';
      //     // }
      //     // 1. 创建目标对象的「空实例」（仅需 ID，无需拉取完整数据）
      //     const spgObject = this.$AV.Object.createWithoutData('SPG', '688aea9d9bf5cd01d7ae8f8c');

      //     if (!this.$refs.captcha.validate()) {        
      //       this.$message.error(this.$t('ContactPage.message.captcha'));
      //       return;
      //     }

      //     // 3. 云端原子操作：直接向 messageData 数组追加元素
      //     // 无需先 get() 数组，服务器会自动处理追加
      //     spgObject.add('messageData', submitData);
      //     // 4. 提交更新（仅传递「数组追加指令」，而非完整数组）
      //     spgObject.save()
      //       .then(() => {
      //         // console.log('新元素已在云端追加到数组',submitData);
      //         // 显示成功提示
      //         this.$message({
      //           message: '留言提交成功，感谢您的反馈！',
      //           type: 'success'
      //         });
      //       })
      //       .catch(error => {
      //         console.error('云端追加失败：', error);
      //       });

      //     // 关闭抽屉
      //     this.drawer = false;
          
      //     // 重置表单
      //     this.resetForm(formName);
      //   } else {
      //     console.log('表单验证失败');
      //     return false;
      //   }
      // });
    },
    // 重置表单
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
    },
    handleClose(done) {
      // 直接调用done()关闭抽屉，不显示确认弹窗
      done();
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      this.showBackToTop = scrollTop > this.screenHeight * 0.5
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
::v-deep .el-drawer.rtl{height: auto;top: auto;border-radius: 12px;}
::v-deep .el-drawer__body {padding: 0px 40px 0!important;}
::v-deep .el-drawer__header > :first-child{
  text-align: left;
}
::v-deep .el-drawer__body {
	padding: 0px 20px 0;
	box-sizing: border-box;
	text-align: left;
}
.floating-actions {
  position: fixed;
  right: 60px;
  bottom: 100px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.flicker{
  animation: shake 0.5s ease-in-out infinite;
}
@keyframes shake {
  0%, 100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-8deg);
  }
  75% {
    transform: rotate(8deg);
  }
}
.floating-actions i{font-size: 30px;z-index: 3;}
.floating-actions .action-btn{animation: goleft 300ms ease-in-out;animation-fill-mode: forwards;-webkit-animation-fill-mode: forwards;-moz-animation-fill-mode: forwards;transform: translateX(50px); opacity: 0}
.floating-actions .action-btn:nth-child(1){animation-delay: 100ms;-webkit-animation-delay: 100ms; /* Firefox */ -moz-animation-delay: 100ms;}
.floating-actions .action-btn:nth-child(2){animation-delay: 200ms;-webkit-animation-delay: 200ms; /* Firefox */ -moz-animation-delay: 200ms;}
.floating-actions .action-btn:nth-child(3){animation-delay: 300ms;-webkit-animation-delay: 300ms; /* Firefox */ -moz-animation-delay: 300ms;}
.floating-actions .action-btn:nth-child(4){animation-delay: 400ms;-webkit-animation-delay: 400ms; /* Firefox */ -moz-animation-delay: 400ms;}
@keyframes goleft {
  0% {
    transform: translateX(50px); opacity: 0;
  }
  100% {
    transform: translateX(0px); opacity: 1;
  }
}
@-webkit-keyframes goleft {
  0% {
    -webkit-transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}

/* 兼容Firefox */
@-moz-keyframes goleft {
  0% {
    -moz-transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -moz-transform: translateX(0px);
    opacity: 1;
  }
}

/* 兼容旧版Opera */
@-o-keyframes goleft {
  0% {
    -o-transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -o-transform: translateX(0px);
    opacity: 1;
  }
}
.action-btn {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #fff;
  color: #303133;
  box-shadow: 0 0px 30px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}
.action-btn-cont{
  position: absolute;
  z-index: -1;
  top: 0;
  right: 0;
  transition: all 300ms;
  width: 60px;
  height: inherit;
  opacity: 0;
  line-height: 60px;
  border-radius: 30px;
  white-space: nowrap;
}
.action-btn-icon {
  position: absolute;
	width: 60px;
	height: 60px;
	line-height: 60px;
	text-align: center;
	z-index: 3;
	border-radius: 50%;
  background: #fff;
}
.action-btn-icon .icon-wenjuan{
  color: #00c250;
  transition: all 300ms;
}
.action-btn:hover .action-btn-icon .icon-wenjuan{
  color: white;
  transition: all 300ms;
}
.action-btn:hover .action-btn-icon{border: 2px solid white;background: #e60012;}
.action-btn:hover {
  transition: all 300ms;
  background-color: #e60012;
  color: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}
.action-btn:hover .action-btn-cont{
  background: #e60012;
  width: auto;
  padding: 0px 80px 0px 30px;
  box-sizing: border-box;
  opacity: 1;
  right: 0;
  z-index: 1;
  transition: all 300ms;
  line-height: 60px;
  font-family: 'RAJDHANIB';
}

/* 修改返回顶部按钮的动画样式，与transition配合 */
/* .back-to-top {

} */

/* 进入动画 */
.backToTop-enter-active {
  animation: fadeInUp 0.3s forwards;
}

/* 退出动画 */
.backToTop-leave-active {
  animation: fadeOutDown 0.3s forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeOutDown {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(20px);
  }
}
::v-deep .el-drawer__mask {
  transition: opacity 0.3s;
}

</style>
